import {Tabs} from 'antd';
import {useLocation} from 'react-router-dom';

import FinalProductScreen from './FinalProductScreen/FinalProductScreen';
import ProductionScreen from './ProductionScreen/ProductionScreen';
import ProductScreen from './ProductScreen/ProductScreen';

const ProductScreenTabs = () => {
  const location = useLocation();

  const items = [
    {
      key: '1',
      label: 'Raw Materials',
      children: <ProductScreen />,
    },
    {
      key: '2',
      label: 'Final Products',
      children: <FinalProductScreen />,
    },
    {
      key: '3',
      label: 'Production',
      children: <ProductionScreen />,
    },
    
  ];

  return (
    <div className={'bg-white rounded-xl'}>
      <h1 className={'header mt-4'}>
            Product Management
      </h1>
      <Tabs
        defaultActiveKey={location.state?.activeTab || '1' }
        items={items}
        // defaultActiveKey={'1'}
        className={'custom-tabs '}
      />
    </div>
  );
};

export default ProductScreenTabs;
